<template>
  <a-card :bordered="false">
    <!-- 顶部筛选区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="日志模块">
              <a-input v-model.trim="queryParam.model" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="事件">
              <a-input v-model.trim="queryParam.action" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="8" :sm="24">
              <a-form-item label="日志类型">
                <a-select v-model="queryParam.type" default-value="0" placeholder="请选择">
                  <a-select-option value>全选</a-select-option>
                  <a-select-option
                    v-for="(item, index) in typeSelect"
                    :key="index"
                    :value="item.value"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item
                label="时间"
                :labelCol="{lg: {span: 7}, sm: {span: 7}}"
                :wrapperCol="{lg: {span: 10}, sm: {span: 17} }"
              >
                <a-range-picker
                  v-model="queryParam.time"
                  style="width: 100%"
                  :disabledDate="disabledDate"
                  :ranges="{ '今天': [moment().startOf('day'), moment().endOf('day')], '本月': [moment().startOf('month'), moment().endOf('day')] }"
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <!-- <a-button type="primary" icon="plus" @click="handleAdd()">新建</a-button> -->
      <a-button
        type="dashed"
        v-if="config.hasAlert"
        @click="tableOption"
      >{{ optionAlertShow && '关闭' || '开启' }} alert</a-button>
    </div>

    <!-- 数据网格 -->
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :alert="options.alert"
      :rowSelection="options.rowSelection"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <span slot="actions" slot-scope="text, record">
        <a @click="handleDetail(record)">详情</a>
      </span>
    </s-table>
  </a-card>
</template>

<script>
import { STable } from '@/components'
import { codeList, logPage } from '@/api/sys'
import { formatDate } from '@/utils/date'
import moment from 'moment'
import storage from '@/utils/storage'
import queryMixin from '@/mixins/queryMixin'

export default {
  name: 'Door',
  mixins: [queryMixin],
  components: {
    STable
  },
  data() {
    return {
      pageSizeOptionsList:['10'],
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: null,
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '模块',
          dataIndex: 'model'
        },
        {
          title: '终端编号',
          dataIndex: 'terminalCode'
        },
        {
          title: '事件',
          dataIndex: 'action'
        },
        {
          title: '类型',
          dataIndex: 'typeName'
        },
        {
          title: '时间',
          dataIndex: 'createTime',
          customRender: text => {
            let date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
        {
          title: '操作',
          width: '50px',
          dataIndex: 'actions',
          scopedSlots: { customRender: 'actions' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        // 日期处理
        if (this.queryParam.time !== undefined && this.queryParam.time.length > 1) {
          this.queryParam['startTime'] = formatDate(new Date(this.queryParam.time[0]), 'yyyy-MM-dd hh:mm:ss')
          this.queryParam['endTime'] = formatDate(new Date(this.queryParam.time[1]), 'yyyy-MM-dd hh:mm:ss')
        } else {
          this.queryParam['startTime'] = null
          this.queryParam['endTime'] = null
        }
        return logPage(Object.assign(parameter, this.queryParam)).then(res => {
          return res.data
        })
      },

      selectedRowKeys: [],
      selectedRows: [],

      // 入场类型下拉
      inTypeSelect: null,
      // 车辆逻辑类型
      ilogicTypeSelect: null,

      // custom table alert & rowSelection
      options: {
        alert: {
          show: false,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: true
    }
  },
  created() {
    this.tableOption()
    this.loadSelectData()

    // 初始化查询条件
    if (!this.queryParam){
      this.queryParam =  {time:[moment().startOf('day'), moment().endOf('day')]}
    }else{
      if (this.queryParam.time.length >0) {
        this.queryParam.time[0] = moment(this.queryParam.time[0])
        this.queryParam.time[1] = moment(this.queryParam.time[1])
      }
    }
  },
  methods: {
    moment,
    disabledDate(current) {
      // Can not select days before today and today
      return current && current > moment().endOf('day')
    },
    loadSelectData() {
      // 从后台拉取下拉列表数据
      new Promise(resolve => {
        const data = codeList({ typeCode: 'sys_log_type' }).then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.typeSelect = res
      })
    },
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: false,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleDetail(record) {
      storage.save('cache-LogDetail', JSON.stringify(record))
      this.$router.push({ name: 'LogDetail' })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    }
  }
}
</script>
